module.exports = __webpack_public_path__ + "static/doge-icon-fddb37135a8e0d8d2ff97e447080bafc.png";